// extracted by mini-css-extract-plugin
module.exports = {"nounTitle":"AuctionActivityNounTitle_nounTitle__3_LLC","wrapper":"AuctionActivityNounTitle_wrapper__2ia4b"};